var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatCommunityPage"},[_c('div',{staticClass:"qrcodeBox"},[_c('img',{attrs:{"src":_vm.qrcode}})]),_c('Loading',{ref:"load"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }